// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"76a26057","377":"e462debd","523":"c435b956","816":"4a89f83b","913":"ce5b446c"}[chunkId] + ".chunk.js";
};